import { render, staticRenderFns } from "./AddTrainingExpenses.vue?vue&type=template&id=06dc4f14&scoped=true"
import script from "./AddTrainingExpenses.vue?vue&type=script&lang=js"
export * from "./AddTrainingExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dc4f14",
  null
  
)

export default component.exports